const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/account/partner_program.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/account/partner_program")({
  beforeLoad: ({
    context
  }) => {
    if (!context.punditUser.current_community_settings?.growth_partner_program_enabled) {
      redirect({
        to: "/account",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});